import type { FormApi, FormState } from 'final-form';

import type { TFirstStepData, TResponseFormatData } from '../models/data';

import { hasAllFieldsFio } from './formatters';
export * from './formatters';

interface IValidateParams {
    /** FormApi из react-final-form */
    form: FormApi;
    /** Значения полей в форме react-final-form */
    values: FormState<TFirstStepData>['values'];
}

/**
 * Проверяет в каких полях есть ошибки, возвращает объект свойств без ошибок
 * @param errors
 * @param values
 * @example errors = {b: 'error'}, values = {a: 1, b: 2 } => { a: 1 }
 */
export const getFormData = ({ errors, values }: Omit<FormState<TFirstStepData>, 'active'>) =>
    Object.keys(values).reduce<TFirstStepData>((previousValue, currentValue) => {
        const field = currentValue as keyof TFirstStepData;
        if (!errors[field]) previousValue[field] = values[field];

        return previousValue;
    }, {});

/** Проходит по всем проставленным свойствам в форме и вызывает blur, чтобы прошла валидация поля */
export const validate = ({ form, values }: IValidateParams) =>
    Object.keys(values).forEach(field => {
        const state = form.getFieldState(field);
        if (state?.value) state?.blur?.();
    });

/** Возвращает true, если поля ФИО заполнены полностью или отсутствуют все свойства, относящиеся к ФИО */
export const isOneField = (data: TResponseFormatData) => {
    const { firstName, lastName, middleName, sex } = data;

    return (hasAllFieldsFio(data) && Boolean(sex)) || (!lastName && !firstName && !middleName);
};
